if (!customElements.get('footer-menu')) {
  customElements.define(
    'footer-menu',
    class FooterMenu extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.details = this.querySelector('details');
        this.summary = this.details?.querySelector('summary');
        if (!this.details || !this.summary) return;

        this.initialized = true;
        this.mobileDefaultOpen = this.details.hasAttribute('data-mobile-open');
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.handleViewportChange = this.syncViewport.bind(this);
        this.handleSummaryClick = (event) => {
          if (this.mediaQuery.matches) event.preventDefault();
        };

        this.summary.addEventListener('click', this.handleSummaryClick);
        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.addListener(this.handleViewportChange);
        }

        this.syncViewport();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.summary.removeEventListener('click', this.handleSummaryClick);
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.removeListener(this.handleViewportChange);
        }
      }

      syncViewport() {
        if (this.mediaQuery.matches) {
          this.details.open = true;
          this.summary.setAttribute('aria-disabled', 'true');
          this.summary.setAttribute('tabindex', '-1');
          return;
        }

        this.details.open = this.mobileDefaultOpen;
        this.summary.removeAttribute('aria-disabled');
        this.summary.removeAttribute('tabindex');
      }
    }
  );
}
